(() => {
  if (window.repairFunnelLoaded) return;
  window.repairFunnelLoaded = true;

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const findForm = () => document.getElementById('RepairEnquiryForm');

  const scrollToForm = (focusTarget) => {
    const anchor = document.getElementById('repair-enquiry');
    if (!anchor) return false;
    anchor.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    if (focusTarget) {
      window.setTimeout(() => focusTarget.focus({ preventScroll: true }), prefersReducedMotion() ? 0 : 600);
    }
    return true;
  };

  const selectService = (service) => {
    const form = findForm();
    if (!form || !service) return null;
    const select = form.querySelector('[data-repair-service-select]');
    if (!select) return null;
    const wanted = service.trim().toLowerCase();
    let match = Array.from(select.options).find((option) => option.value.trim().toLowerCase() === wanted);
    if (!match) {
      match = new Option(service, service);
      select.add(match);
    }
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    const deviceSelect = form.querySelector('[data-repair-device-select]');
    const device = match.dataset.device || '';
    if (deviceSelect && device && !deviceSelect.value) {
      const deviceMatch = Array.from(deviceSelect.options).find((o) => o.value.toLowerCase() === device.toLowerCase());
      if (deviceMatch) deviceSelect.value = deviceMatch.value;
    }
    return select;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-repair-scroll]');
    if (!trigger) return;
    const form = findForm();
    if (!form) return;
    event.preventDefault();
    const service = trigger.dataset.repairService;
    const select = service ? selectService(service) : null;
    const focusTarget = select ? form.querySelector('[name="contact[name]"]') : null;
    scrollToForm(focusTarget);
    if (history.replaceState) history.replaceState(null, '', '#repair-enquiry');
  });

  const initForm = (form) => {
    if (!form || form.dataset.repairReady) return;
    form.dataset.repairReady = 'true';

    const dateInput = form.querySelector('input[type="date"]');
    if (dateInput) {
      const today = new Date();
      const local = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
      dateInput.min = local.toISOString().slice(0, 10);
    }

    const emailVisible = form.querySelector('[data-repair-customer-email]');
    const emailHidden = form.querySelector('[data-repair-reply-email]');
    const summary = form.querySelector('[data-repair-summary]');
    const summaryList = summary ? summary.querySelector('ul') : null;
    const messagesHost = form.closest('[data-repair-messages]');
    const messages = messagesHost ? messagesHost.dataset : {};
    form.noValidate = true;

    const fieldError = (field) => {
      const id = field.getAttribute('aria-describedby');
      if (!id) return null;
      return id
        .split(' ')
        .map((part) => document.getElementById(part))
        .find((el) => el && el.classList.contains('repair-field__error'));
    };

    const setError = (field, message) => {
      const errorEl = fieldError(field);
      if (message) {
        field.setAttribute('aria-invalid', 'true');
        if (errorEl) {
          errorEl.querySelector('span').textContent = message;
          errorEl.hidden = false;
        }
      } else {
        field.removeAttribute('aria-invalid');
        if (errorEl) errorEl.hidden = true;
      }
    };

    const validateField = (field) => {
      const value = field.type === 'checkbox' ? field.checked : field.value.trim();
      if (field.hasAttribute('data-required') && !value) {
        return field.dataset.errorRequired || messages.errorRequired;
      }
      if (field.type === 'email' && field.value.trim()) {
        const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(field.value.trim());
        if (!ok) return messages.errorEmail;
      }
      if (field.type === 'tel' && field.value.trim()) {
        const digits = field.value.replace(/\D/g, '');
        if (digits.length < 9 || digits.length > 15) return messages.errorPhone;
      }
      return '';
    };

    const fields = Array.from(form.querySelectorAll('[data-repair-validate]'));

    fields.forEach((field) => {
      const evt = field.type === 'checkbox' || field.tagName === 'SELECT' ? 'change' : 'blur';
      field.addEventListener(evt, () => {
        if (field.getAttribute('aria-invalid') === 'true' || field.value) setError(field, validateField(field));
      });
      field.addEventListener('input', () => {
        if (field.getAttribute('aria-invalid') === 'true') setError(field, validateField(field));
      });
    });

    form.addEventListener('submit', (event) => {
      const problems = [];
      fields.forEach((field) => {
        const message = validateField(field);
        setError(field, message);
        if (message) problems.push({ field, message });
      });

      if (problems.length) {
        event.preventDefault();
        if (summary && summaryList) {
          summaryList.innerHTML = '';
          problems.forEach(({ field, message }) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = `#${field.id}`;
            a.textContent = message;
            a.addEventListener('click', (e) => {
              e.preventDefault();
              field.focus();
            });
            li.appendChild(a);
            summaryList.appendChild(li);
          });
          summary.hidden = false;
          summary.focus();
        } else {
          problems[0].field.focus();
        }
        return;
      }

      if (summary) summary.hidden = true;
      if (emailHidden) {
        const customerEmail = emailVisible ? emailVisible.value.trim() : '';
        emailHidden.value = customerEmail || emailHidden.dataset.fallback || '';
      }
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('loading');
      }
    });

    const params = new URLSearchParams(window.location.search);
    const preset = params.get('service');
    if (preset) selectService(preset);
  };

  const initAll = () => initForm(findForm());

  const success = document.querySelector('[data-repair-success]');
  if (success) {
    success.scrollIntoView({ block: 'center' });
    success.focus({ preventScroll: true });
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
